import { render, staticRenderFns } from "./CurrencyPicker.vue?vue&type=template&id=4a0cd324&scoped=true&lang=html&"
import script from "./CurrencyPicker.vue?vue&type=script&lang=js&"
export * from "./CurrencyPicker.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyPicker.vue?vue&type=style&index=0&id=4a0cd324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0cd324",
  null
  
)

export default component.exports